import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { showToast } from '@deeptrue-frontend/ui';

import { Dashboard } from 'components/Layout';
import api from 'api/api';
import { OrgnizationInvitationsType } from 'store/modules/organizations/organizations';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import Forms from 'components/Forms';
import { useFormatMessage } from 'components/IntlProvider';
import AdminMenu from 'components/AdminMenu/AdminMenu';

const { ROUTES, Redirect } = RouterProvider;

interface OrganizationUsersInviteProps
  extends RouteComponentProps<{
    codename: string;
    organizationId: string;
  }> {
  invitations: OrgnizationInvitationsType;
  setOrganizationsInvitations: (payload: any) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: '420px',
      marginTop: theme.spacing(3),
      padding: theme.spacing(2),
      overflowX: 'auto',
      border: '1px solid #CECECA',
      boxShadow: ' 0 4px 12px 0 rgba(0,0,0,0.1)',
      borderRadius: '10px',
    },
  })
);

const OrganizationUsersInvite = ({
  match: { params },
  history,
  location,
}: OrganizationUsersInviteProps) => {
  const classes = useStyles();
  const [organization, setOrganization] = useState();
  const t = useFormatMessage();

  useEffect(() => {
    api.resources
      .getOrganization({
        id: params.organizationId,
      })
      .then(({ data }) => {
        setOrganization(data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendInvitation = ({ emails }: { [key: string]: any }) =>
    api.resources
      .inviteOrganizationUser({
        organization_name: params.codename,
        emails: emails.split(','),
      })
      .then(({ data }) => {
        if (data.already_invited.length > 0) {
          showToast({
            type: 'warn',
            title: t(
              'errors.invitation.alreadyInvited',
              'Users already invited: {mail}.',
              {
                mail: data.already_invited.join(', '),
              }
            ),
          });
        }

        if (data.invalid_emails.length > 0) {
          showToast({
            type: 'error',
            title: t(
              'errors.invitation.invalidEmails',
              'Invalid email addresses: {mail}.',
              {
                mail: data.invalid_emails.join(', '),
              }
            ),
          });
        }

        history.push(
          `/admin/organizations/${params.codename}/users/invitations`
        );
      })
      .catch((err) => {
        Forms.helpers.throwError(err.response.data);
      });

  if (!params.codename) {
    return <Redirect to={ROUTES.ADMIN.ORGANIZATIONS.LIST} />;
  }
  return (
    <Dashboard
      title={`Invite new users to ${
        // @ts-ignore
        organization && organization.name
      } organization`}
      location={location}
    >
      <Grid item xs={12}>
        <AdminMenu />
      </Grid>
      <Paper className={classes.root}>
        <Forms.InviteUser onSubmit={sendInvitation} />
      </Paper>
    </Dashboard>
  );
};

export default OrganizationUsersInvite;
